export default "__VITE_ASSET__C44CN3SK__"